export default __webpack_public_path__ + "static/media/refresh.d7ca54a9.svg";